export default "__VITE_ASSET__cJTp39X2__"